import { Ornament } from "@/components/ui/Ornament";
import { Link } from "react-router-dom";

type Props = {
  eventTitle?: string;
};

export function Footer({ eventTitle }: Props) {
  return (
    <footer className="relative mt-24 border-t border-line/60 bg-surface/60 backdrop-blur">
      <div className="mx-auto w-full max-w-6xl px-5 py-12 sm:px-6 lg:px-8">
        <Ornament className="mb-10" />
        <div className="flex flex-col items-center gap-2 text-center">
          <p className="font-display text-xl font-light text-ink">Mobeen Center</p>
          <p className="text-sm text-muted">
            {eventTitle ? <>Hosting · {eventTitle}</> : <>Community programs and gatherings</>}
          </p>
          <nav
            aria-label="Legal"
            className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-muted"
          >
            <Link
              to="/privacy"
              className="rounded-sm hover:text-accent transition-colors focus-ring"
            >
              Privacy
            </Link>
            <Link to="/terms" className="rounded-sm hover:text-accent transition-colors focus-ring">
              Terms
            </Link>
            <Link
              to="/terms#refunds"
              className="rounded-sm hover:text-accent transition-colors focus-ring"
            >
              Refund Policy
            </Link>
          </nav>
          <p className="mt-5 text-xs text-subtle">
            © {new Date().getFullYear()} Mobeen Center. All rights reserved.
          </p>
          <Link
            to="/admin"
            className="mt-3 rounded-sm text-[11px] uppercase tracking-[0.18em] text-subtle hover:text-accent transition-colors focus-ring"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
